import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";

class NoticesFormPresenter extends BaseFormPresenter {
  constructor(view, getObjectUseCase, upsertUseCase, findObjectUseCase) {
    super();
    this.view = view;
    this.getObjectUseCase = getObjectUseCase;
    this.upsertUseCase = upsertUseCase;
    this.findObjectUseCase = findObjectUseCase;
  }

  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  // async fetchOffices() {
  //   const getOffices = this.findObjectUseCase;
  //   if (!getOffices) {
  //     console.error("findObjectUseCase is undefined");
  //     return;
  //   }
  //   const query = {
  //     where: {
  //       status: "active",
  //     },
  //   };
  //   try {
  //     const fetchedData = await getOffices?.execute("offices", query);
  //     const officeNames = fetchedData?.map((office) => office.name);
  //     return officeNames;
  //   } catch (error) {
  //     console.error("Failed to fetch offices:", error);
  //   }
  // }

  // async fetchDivisions(selectedOffices) {
  //   const getDivisions = this.findObjectUseCase;
  //   const query = {
  //     where: {
  //       office: {
  //         $in: selectedOffices, // Assuming your query language supports the $in operator
  //       },
  //     },
  //   };
  //   try {
  //     const fetchedData = await getDivisions?.execute("Division", query);
  //     const divisionName = fetchedData.map((division) => division.name);
  //     //   console.log("FFFEEE: ", fetchedData);
  //     return divisionName;
  //   } catch (error) {
  //     console.error("Failed to fetch divisions:", error);
  //   }
  // }

  // async fetchSections(selectedDivision) {
  //   const getSections = this.findObjectUseCase;
  //   const query = {
  //     where: {
  //       division: {
  //         $in: selectedDivision, // Assuming your query language supports the $in operator
  //       },
  //     },
  //   };
  //   try {
  //     const fetchedData = await getSections?.execute("Sections", query);
  //     const sectionName = fetchedData.map((section) => section.name);
  //     return sectionName;
  //   } catch (error) {
  //     console.error("Failed to fetch divisions:", error);
  //   }
  // }

  // async fetchDesignations() {
  //   const getDesignation = this.findObjectUseCase;
  //   try {
  //     const fetchedData = await getDesignation?.execute("position_titles");
  //     const filtereSections = fetchedData.map((data) => data.position_title);
  //     return filtereSections;
  //   } catch (error) {
  //     console.error("Failed to fetch divisions:", error);
  //   }
  // }

  async fetchEmployees(field, value) {
    let query = {};
    if (field !== "" && value !== "") {
      query = { where: { [field]: { $in: value } } };
    }
    const getEmployee = this.findObjectUseCase;
    // if (field !== "" && value !== "") {
    try {
      const fetchedData = await getEmployee?.execute("employees", query);
      return fetchedData;
    } catch (error) {
      console.error("Failed to fetch divisions:", error);
    }
    // }
  }

  async fetchTemplates() {
    const getTemplates = this.findObjectUseCase;
    try {
      const fetchedData = await getTemplates?.execute("notice_templates");
      // const filtereSections = fetchedData.map((data) => data.name);
      return fetchedData;
    } catch (error) {
      console.error("Failed to fetch divisions:", error);
    }
  }

  async fetchTitle() {
    const getTitle = this.findObjectUseCase;
    try {
      const fetchedData = await getTitle?.execute("notice_templates");
      // const filtereSections = fetchedData.map((data) => data.name);
      return fetchedData;
    } catch (error) {
      console.error("Failed to fetch divisions:", error);
    }
  }
}

export default NoticesFormPresenter;
